import TrendingPostPage from './TrendingPostPage'

export default TrendingPostPage
